import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class JsonConfiguration {

  private translateKey: string = '';

  constructor(private translateService: TranslateService) {
  }

  setTranslateKey(translateKey: string): void {
    this.translateKey = translateKey;
  }

  setTitle(): string {
    return this.translateService.instant(`${this.translateKey}.title`);
  }

  setSubtitle(): string {
    return this.translateService.instant(`${this.translateKey}.subtitle`);
  }

  setProtectedTitle(): string {
    return this.translateService.instant(`${this.translateKey}.protected`);
  }

  setPriceSubtitle(): string {
    return this.translateService.instant(`${this.translateKey}.priceSubtitle`);
  }

  setYearWord(): string {
    return this.translateService.instant(`${this.translateKey}.year`);
  }

  setMonthWord(): string {
    return this.translateService.instant(`${this.translateKey}.month`);
  }
}
